(ns renolit-roofing-service.layout.form.form-item.time-picker
  (:require [goog.object :as g]
            [goog.string.format]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.localization :refer [t]]
            [renolit-roofing-service.shared.util.time :as util.time]))

(defn- on-change-event-handler
  [opts tmp-value]
  (let [valid-value-regex #"^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
        unfinished-value-regex #"^(?:([0-1]?[0-9]|2[0-3])|$)(?:\:|$)(?:[0-5]|$)(?:[0-9]|$)"]
    (fn [e]
      (let [event-value (g/getValueByKeys e "target" "value")]
        (when (re-matches unfinished-value-regex event-value)
          (if-not (re-matches valid-value-regex event-value)
            (do
              (reset! tmp-value event-value)
              (form.form-item/on-change-event-handler opts :on-change nil))
            (let [new-value (util.time/parse-local-time event-value {})]
              (reset! tmp-value nil)
              (form.form-item/on-change-event-handler opts :on-change new-value))))))))

(defmethod form.form-item/form-item-component :time-picker
  [{:keys [context path] :as _opts}]
  (let [component-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])
        tmp-value (r/atom nil)]
    (fn [{:keys [state path disabled? label placeholder
                 label-transl-kw placeholder-transl-kw
                 css-class-prefix mandatory? full-line?]
          :as opts}]
      [:div.form-item
       {:class [(when disabled? "form-item--disabled")
                (when css-class-prefix css-class-prefix)
                (when full-line? "form-item--full-line")
                (when (seq @form-errors) "form-item--error")]}
       (when (or label-transl-kw label)
         [:label.form-item__label
          (cond-> {:for component-id}
            css-class-prefix
            (assoc :class (str css-class-prefix "__label"))

            (seq @form-errors)
            (assoc :title (form.error/form-error->msg (first @form-errors))))
          (or (t [label-transl-kw]) label)
          (when mandatory?
            [:span.form-item__mandatory "*"])])
       [:div.form-item__input-wrapper
        [layout.icon/icon
         {:class "form-item__input-icon"
          :key :clock}]
        [:input.form-item__input
         (cond-> {:id component-id
                  :disabled (boolean disabled?)
                  :value (str (or @tmp-value (get-in @state path) ""))
                  :on-change (on-change-event-handler opts tmp-value)
                  :class []
                  :placeholder "hh:mm"}
           placeholder-transl-kw
           (assoc :placeholder (t [placeholder-transl-kw]))

           placeholder
           (assoc :placeholder placeholder)

           css-class-prefix
           (update :class conj (str css-class-prefix "_time-input")))]]
       (when (seq @form-errors)
         [form.error/error-label @form-errors])])))
